
import React, {Fragment,useState, useEffect} from 'react'
import axios from 'axios';
import { useHistory } from "react-router-dom";

export const Listadostandviruales = (props) => {
    const history = useHistory();
  
    const navigateTo = (id) => {
        id != '-1' ?
        history.push(`/standvirtual/${id}`)
        :
        history.push(`/`)
    }
    
    return  (
        <Fragment>
            <div className="listadoStandViruales">
                {
                    props.items.map(item =>
                        <Fragment>
                            <div className="standVirtuales">
                                {item.titulo !== null && <div className="titulStand">{item.titulo}</div>}
                                <a href={`${process.env.REACT_APP_FULL_URL}/standvirtual/${item.enlace}/${props.idEvento}`} target="_blank"><img  className="itemStand" src={item.imagen} /></a>
                            </div> 
                      
                        </Fragment>
                    )
                }
            </div>
        </Fragment> 
    )
    
}
